import React from "react";
import { Modal, ModalDialog, Button } from "@mui/joy";
import { buttonStyles } from "../camera/CameraButtonStyles";

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
  confirmAction: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  cancelLabel,
  confirmAction,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <ModalDialog className="rounded-2xl p-0 overflow-hidden max-w-xs w-[90%] sm:w-[30%] relative mx-auto">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 text-xl font-light cursor-pointer hover:text-gray-700 bg-transparent border-none"
        >
          ×
        </button>
        <div className="p-1">
          <h2 className="text-xl font-medium mb-2">{title}</h2>
          <p className="text-sm font-extralight text-gray-500 mb-6">
            {description}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <Button
              onClick={confirmAction}
              color="danger"
              className="w-full"
              sx={buttonStyles.discardButton}
            >
              {confirmLabel}
            </Button>
            <Button
              onClick={onClose}
              variant="plain"
              color="neutral"
              className="w-full"
              sx={{
                ...buttonStyles.cancelButton,
                fontWeight: 600,
                color: "#2B2D7D",
              }}
            >
              {cancelLabel}
            </Button>
          </div>
        </div>
      </ModalDialog>
    </Modal>
  );
};

export default ConfirmationModal;
